// Libraries
import React from 'react';
import PropTypes from 'prop-types';

const ComTabs = ({ tabList, selectedTab, setSelectedTab }) => (
    <div className="comm-tabs">
        <ul>
            {tabList.map(tab => (
                <li
                    key={tab.value}
                    className={tab.value === selectedTab ? 'selected' : ''}
                    onClick={() => setSelectedTab(tab.value)}
                >
                    {tab.label}
                </li>
            ))}
        </ul>
    </div>
);

ComTabs.propTypes = {
    tabList: PropTypes.array,
    selectedTab: PropTypes.string,
    setSelectedTab: PropTypes.func,
};

export default ComTabs;
